import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const createStore = () => {
	Vue.use(Vuex);
	return new Vuex.Store({
		config: window.$config,
		plugins: [
			createPersistedState({
				key: 'hpid-sso',
				paths: ['lang.lang']
			})
		]
	});
};

export default createStore;
